import React from 'react';
import './PromotionTransactionBadge.css';

const BADGE_CLASS_BY_STATUS = {
    'zapłacono': 'promo-transaction-badge--paid',
    oczekuje: 'promo-transaction-badge--pending',
    anulowano: 'promo-transaction-badge--cancelled',
    active: 'promo-transaction-badge--paid',
    scheduled: 'promo-transaction-badge--paid',
    finished: 'promo-transaction-badge--inactive',
    pending: 'promo-transaction-badge--pending',
    cancelled: 'promo-transaction-badge--cancelled',
};

function PromotionTransactionBadge({ label }) {
    const normalized = String(label || '').toLowerCase();
    const badgeClass = BADGE_CLASS_BY_STATUS[normalized] || 'promo-transaction-badge--inactive';

    return (
        <span className={`promo-transaction-badge ${badgeClass}`}>
            {label}
        </span>
    );
}

export default PromotionTransactionBadge;
